let data = {
  'percent': {
    breaks: [ 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9 ],
    labels: [ '0% - 10%', '10% - 20%', '20% - 30%', '30% - 40%', '40% - 50%', '50% - 60%', '60% - 70%', '70% - 80%', '80% - 90%', '90% - 100%' ]
  },
  'stat7': {
    unit: 'hours',
    breaks: [ 0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5 ],
    labels: [ '< 0.5', '0.5 - 1.0', '1.0 - 1.5', '1.5 - 2.0', '2.0 - 2.5', '2.5 - 3.0', '3.0 - 3.5', '3.5 - 4.0', '4.0 - 4.5', '> 4.5' ]
  },
  'stat8': {
    unit: 'days',
    breaks: [ 45, 90, 135, 180, 225, 270, 315, 360, 405 ],
    labels: [ '< 45', '45 - 90', '90 - 135', '135 - 180', '180 - 225', '225 - 270', '270 - 315', '315 - 360', '360 - 405', '> 405' ]
  }
}

export default data



// WEBPACK FOOTER //
// ./src/options/legends.js